import React from "react";
import {Link, useParams} from "react-router-dom";
import {ArrowLeft, ArrowRight, Clock3, Layers3, ShieldCheck} from "lucide-react";
import PublicNav from "../../components/layout/PublicNav";
import PublicFooter from "../../components/layout/PublicFooter";
import PageMeta from "../../components/seo/PageMeta";

const platforms={
  orbit:{name:"TRITAL Orbit™",tagline:"Workforce Intelligence",domain:"orbit.tritalcare.com"},
  nexus:{name:"TRITAL Nexus™",tagline:"Connected Workforce Operations",domain:"nexus.tritalcare.com"},
};
export default function PlatformComingSoon(){
 const {platform}=useParams();const p=platforms[platform];
 if(!p) return <div className="min-h-screen bg-white"><PublicNav/><main className="max-w-4xl mx-auto px-6 py-24"><h1 className="font-display font-black text-3xl">Platform not found</h1><Link to="/platforms" className="mt-6 inline-flex text-trital-navy underline">Back to Platforms</Link></main><PublicFooter/></div>;
 return <div className="min-h-screen bg-white" data-testid={"coming-soon-"+platform}>
  <PageMeta title={p.name+" | Coming Soon — TRITAL Care®"}
   description={p.name+" is being prepared as a separate TRITAL Care platform. See existing TRITAL workforce services while the new app is validated."}
   canonical={"https://www.tritalcare.com/platforms/"+platform}/>
  <PublicNav/>
  <main className="bg-[#f7f9fd] relative min-h-[70vh]">
   <div className="absolute inset-0 bg-trital-mesh opacity-40 pointer-events-none"/>
   <div className="relative max-w-4xl mx-auto px-5 sm:px-8 py-20 sm:py-28 text-center">
    <div className="mx-auto flex w-16 h-16 rounded-2xl bg-[#eaf0fd] text-trital-navy items-center justify-center"><Layers3 size={30}/></div>
    <div className="mt-7 inline-flex items-center gap-2 text-xs font-extrabold tracking-widest text-trital-red uppercase"><Clock3 size={16}/> In development</div>
    <h1 className="mt-5 font-display font-black text-4xl sm:text-6xl tracking-tight leading-tight text-[#10295b]">{p.name}<br/><span className="text-trital-red">Coming soon.</span></h1>
    <p className="mt-5 mx-auto max-w-xl text-slate-600 leading-relaxed">{p.tagline}. We are validating secure access, application performance, and readiness before opening this platform.</p>
    <div className="mt-7 rounded-2xl border border-slate-200 bg-white max-w-md mx-auto p-4">
     <div className="text-xs text-slate-500 font-bold">Planned destination</div>
     <div className="font-bold text-[#16346b] mt-1">{p.domain}</div>
     <div className="text-xs text-slate-500 mt-2">This domain is not yet advertised as live.</div>
    </div>
    <div className="mt-8 flex gap-3 justify-center flex-wrap">
     <Link to="/platforms" className="rounded-full px-6 py-3 border border-slate-300 bg-white text-[#123364] font-bold text-sm inline-flex gap-2 items-center"><ArrowLeft size={16}/> All Platforms</Link>
     <Link to="/workforce-os" className="rounded-full px-6 py-3 bg-trital-navy text-white font-bold text-sm inline-flex gap-2 items-center">Explore Workforce OS <ArrowRight size={16}/></Link>
    </div>
   </div>
  </main>
  <PublicFooter/>
 </div>;
}
